// extracted by mini-css-extract-plugin
export default {"container":"CriticalSection_container__XYOcp","title":"CriticalSection_title__vDvuT","list":"CriticalSection_list__arRwb"};